<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="item_title">小程序</span>
        <el-autocomplete
          v-model="parameterNames.mini_program"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '小程序'"
          @clear="(parameterNames.mini_program = null),(parameter.mini_program_id = null)"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">投放组</span>
        <el-autocomplete
          v-model="parameterNames.release_group_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投放组'"
          @select="handleSelect"
          @clear="release_group_id = null"
        />
      </div>
      <div class="item">
        <span class="item_title">投手</span>
        <el-autocomplete
          v-model="parameterNames.pitcher_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投手'"
          @select="handleSelect"
          @clear="pitcher_id = null"
        />
      </div>
      <div class="item">
        <span class="item_title">日期</span>
        <el-date-picker
          v-model="date"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>
      <el-button style="height:37px" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
      <el-button style="height:37px" type="primary" icon="el-icon-refresh-left" @click="reset">重置</el-button>
      <el-button style="height:37px" type="primary" icon="el-icon-bottom" @click="reportExport">导出总计报表</el-button>
    </div>
    <div class="content1">
      <div>合计</div>
      <div>
        <div>消耗：</div>
        <div>{{ tableData.total_data && tableData.total_data.sum_cost ? tableData.total_data.sum_cost : 0 }}</div>
      </div>
      <div>
        <div>首日LTV：</div>
        <div>{{ tableData.total_data && tableData.total_data.sum_0d_ltv ? tableData.total_data.sum_0d_ltv : 0 }}</div>
      </div>
      <div>
        <div>首日roi：</div>
        <div>{{ tableData.total_data && tableData.total_data.sum_0d_roi ? tableData.total_data.sum_0d_roi : 0 }}</div>
      </div>
      <div>
        <div>3日LTV：</div>
        <div>{{ tableData.total_data && tableData.total_data.sum_3d_ltv ? tableData.total_data.sum_3d_ltv : 0 }}</div>
      </div>
      <div>
        <div>3日roi：</div>
        <div>{{ tableData.total_data && tableData.total_data.sum_3d_roi ? tableData.total_data.sum_3d_roi : 0 }}</div>
      </div>
    </div>
    <div>
      <el-table
        ref="tableRef"
        v-loading="loading"
        :data="tableData.list"
        max-height="650"
        style="width: 100%"
        border
      >
        <el-table-column prop="channel_date" label="日期" width="120" />
        <el-table-column prop="mini_program_name" label="小程序名称" width="170" />
        <el-table-column prop="release_group_name" label="投放组" width="120" />
        <el-table-column prop="pitcher_name" label="投手" width="120" />
        <el-table-column prop="bind_id" label="绑定关系" width="120" />
        <el-table-column prop="cost" label="消耗" width="120" />
        <el-table-column prop="attribution_micro_game_0d_ltv" label="首日LTV" width="120" />
        <el-table-column prop="attribution_micro_game_0d_roi" label="首日roi" width="120" />
        <el-table-column prop="chain_cost" label="消耗环比" width="120" />
        <el-table-column prop="chain_0d_roi" label="roi环比" width="120" />
        <el-table-column prop="chain_3d_roi" label="三日roi比" width="120" />
        <el-table-column prop="ayer_cost" label="消耗(昨天)" width="120" />
        <el-table-column prop="ayer_attribution_micro_game_0d_roi" label="首日roi(昨天)" width="120" />
        <el-table-column prop="ayer_attribution_micro_game_0d_roi" label="首日LTV(昨天)" width="120" />
        <el-table-column prop="proportion_cost" label="消耗整体占比" width="120" />
        <el-table-column prop="attribution_micro_game_3d_ltv" label="三日LTV" width="120" />
        <el-table-column prop="attribution_micro_game_3d_roi" label="三日roi" width="120" />
        <el-table-column prop="ayer_attribution_micro_game_3d_ltv" label="三日LTV(昨天)" width="120" />
        <el-table-column prop="ayer_attribution_micro_game_3d_roi" label="三日roi(昨天)" width="120" />
      </el-table>
    </div>

    <pagination-right
      :total="tableData.count"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

  </div>
</template>

<script>
import {
  getTotalReportList,
  getReleaseGroupList,
  getListOfPitchersInTheLaunchGroup,
  modifyConsumption,
  exportTotalReport,
  getAPPList
} from '@/api/TKreleaseGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
    /* Details */
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        page_size: 10,
        mini_program_id: null,
        release_group_id: null,
        pitcher_id: null
      },
      parameterNames: {
        mini_program: null, // 小程序
        release_group_id_name: null, // 投放组
        pitcher_id_name: null // 投手
      },
      current: null,
      date: [],
      activeItem: null,
      activeText: null,
      drawerItem: {},
      optionbook: []
    }
  },
  created() {
    window.aa = this
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    async getDataList(obj = {}) {
      this.loading = true
      const ob1 = Object.keys(obj).length ? obj : this.parameter
      const data = await getTotalReportList({ ...ob1,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null })
      this.tableData = data.data
      this.loading = false
    },

    // 修改
    modify(row) {
      this.dialogVisible = true
      this.drawerItem = row
    },

    // 分页
    fetchPageSize(s) {
      this.parameter.page_size = s
      this.search(true)
    },

    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.search(true)
    },

    // 搜索
    async querySearchAsync(queryString, cb) {
      let currentFunc = null
      const obj = {
        '小程序': 'name',
        '投放组': 'release_group_name',
        '投手': 'user_name'
      }

      switch (this.current) {
        case '小程序': currentFunc = getAPPList
          break
        case '投放组': currentFunc = getReleaseGroupList
          break
        case '投手': currentFunc = getListOfPitchersInTheLaunchGroup
          break
      }
      if (!currentFunc) {
        return
      }
      if (this.current === '投手' && !this.parameter.release_group_id) {
        const obj1 = {
          '投手': '请先选投放组，才能选投手'
        }
        this.$message({
          message: obj1[this.current],
          type: 'warning'
        })
        cb()
        return
      }
      const data = await currentFunc({
        name: queryString || null,
        group_id: this.current === '投手' ? this.parameter.release_group_id.address : null,
        type: this.current === '投放组' ? 2 : null
      })
      console.log(data)
      if (this.current === '投手') {
        cb(
          data.data.group_user.map(item => {
            return {
              value: item.nickname,
              address: item.bind_id
            }
          })
        )
        return
      }
      cb(data.data.list.map((item) => {
        return {
          value: item[obj[this.current]],
          address: item.id
        }
      }))
    },

    // 选中哪一项
    handleSelect(item) {
      switch (this.current) {
        case '小程序' : this.parameter.mini_program_id = item
          break
        case '投放组' : this.parameter.release_group_id = item
          break
        case '投手' : this.parameter.pitcher_id = item
          break
      }
    },

    // 搜索
    search(value) {
      value || (this.parameter.page = 1)
      const obj = {
        mini_program_id: 'mini_program',
        release_group_id: 'release_group_id_name',
        pitcher_id: 'pitcher_id_name'
      }
      const keys = Object.keys(this.parameter)
      const obj1 = {}
      keys.map((key, index) => {
        if (this.parameter[key] && (this.parameter[key].value === this.parameterNames[obj[key]]) && key !== 'page' && key !== 'page_size') {
          obj1[key] = this.parameter[key].address
        } else if (key !== 'page' && key !== 'page_size') {
          obj1[key] = null
        } else {
          obj1[key] = this.parameter[key]
        }
      })
      if (this.parameterNames.belong_type_name) {
        obj1.belong_type = this.parameterNames.belong_type_name
      }

      value === '导出' || this.getDataList(obj1)
      return obj1
    },

    // 重置
    reset(value) {
      this.parameter = {
        page: 1,
        page_size: 10,
        mini_program_id: null,
        release_group_id: null,
        pitcher_id: null
      }
      this.parameterNames = {
        mini_program: null, // 小程序
        release_group_id_name: null, // 投放组
        pitcher_id_name: null // 投手
      }
      this.date = []
      this.current = null
      this.getDataList()
    },

    // 导出报表
    async reportExport() {
      const obj = this.search('导出')
      await exportTotalReport({ ...obj,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null
      })
      this.$message({
        message: '已在后台中导出',
        type: 'success'
      })
      this.reset('no')
    },

    async blur1() {
      if (this.activeItem.cost !== this.activeText) {
        try {
          await modifyConsumption({ id: this.activeItem.id, cost: this.activeText })
          this.$message({
            message: '修改消耗成功',
            type: 'success'
          })
          this.getDataList()
        } catch (err) {
          this.activeItem = null
          this.activeText = null
        }
      }
      this.activeItem = null
      this.activeText = null
    }

  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.content{
   .item{
     display: flex;
     align-items: center;
    .item_title{
       display: inline-block;
       width: 100px;
    }
    .item_input{
       width: 200px
    }
   }
}

.selectionArea{
  display: flex;
  flex-wrap: wrap;
  .item{
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
    .item_title{
       margin-right: 10px;
       display: inline-block;
    }
    .item_input{
      width:200px
    }
  }
}

 .powder {
   background: rgb(248, 216, 216);
 }
 .green {
   background: rgb(52, 229, 54);
 }
 .yellow {
   background: rgb(255, 247, 173);
 }
 .blue {
   background: rgb(158, 211, 252);
 }
 .red {
   background: #ffa500;
 }
 .magRig {
   margin-right: 10px;
 }
 .magLfte {
   margin-left: 10px;
 }
 .chong{
          display: inline-block;
          width: 13px;
          height: 86%;
          margin-left: 6px;
    }
    .mybox{
      margin-left: 20px;
      display: flex;
      align-items: center;
    }
</style>

<style>
.publicItems .el-dialog{
  margin-top: 6vh !important;
}
.content1{
  padding: 13px;
  color: #000;
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: bold;
}
.content1>div:nth-child(1){
  margin-right: 7rem;
}
.content1>div{
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 3rem;
}
.content1>div>div:nth-child(2){
  color: rgb(138, 37, 37);
}
</style>
